import React from 'react';
import SearchableSettingsPage, { savedTitleSearch } from './SearchableSettingsPage';
import { Button, Jumbotron, Modal } from 'react-bootstrap';

import AssetCategoryList from './AssetCategoryList.js';
import CategoryAdd from './CategoryAdd.js';
import MusterPointChange from './MusterPointChange.js';

import './SettingsPage.css';

class MusterPoints extends SearchableSettingsPage {
    searchConfig = { key: "muster-points", endpoint: "muster_point_list", field: "title" };

    constructor(props) {
        super(props);

        let category = {
            categoryId: "1",
            title: "",
            colour: "",
            baselineRecording: "",
            x: "0.0",
            y: "0.0",
            z: "0.0",
            azimuth: "0.0"
        }

        this.state = {
            allRows: [],
            searchText: savedTitleSearch("muster-points"),
            searchError: "",
            numCategories: 1,
            categoryTitle: 'Muster Point',
            showCategoryStringPopup: false,
            categoryStringInput: '',
            showUploadPopup: false,
            uploadMsg: '',
            showAddCategory: false,
            updateCategoryVisible: false,
            updateCategory: category,
            errMsg: '',
            startIndex: 0,
            pageId: 1,
            pageSize: 10
        };

        this.frmAddCategory = React.createRef();
    }

    componentDidMount() {
        this.reloadRows();

        fetch('get_muster_point_string', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
        .then(res => res.json())
        .then((data) => {
            if (data && data[0] && data[0].value) {
                this.setState({ categoryTitle: data[0].value });
            }
        })
        .catch(console.log)
    }

    reloadCategories = () => this.reloadRows();

    reloadSettings = () => this.reloadRows();

    handleAddCategory = () => {
        this.setState({
            showAddCategory: true,
            errMsg: ''
        });
    }

    handleDownloadCsv = () => {
        //navigating (rather than fetching) lets the servlet's Content-Disposition
        //attachment header drive the browser's download UI without leaving the page
        window.location.href = 'muster_point_export';
    }

    handleShowUpload = () => {
        this.setState({ showUploadPopup: true, uploadMsg: '' });
    }

    handleCloseUpload = () => {
        this.setState({ showUploadPopup: false });
    }

    uploadXlsxFile = (file) => {
        if (!file) {
            return;
        }

        this.setState({ uploadMsg: 'Uploading...' });

        const formData = new FormData();
        formData.append('file', file);

        fetch('muster_point_import', {
            method: 'POST',
            body: formData
        })
        .then(res => res.json())
        .then(data => {
            if (data && data[0] && data[0].success === 'true') {
                this.setState({ uploadMsg: data[0].msg });
                this.reloadCategories();
            }
            else {
                this.setState({ uploadMsg: (data && data[0] && data[0].msg) || 'Upload failed' });
            }
        })
        .catch(() => {
            this.setState({ uploadMsg: 'Upload failed' });
        })
    }

    handleUploadFileSelected = (e) => {
        const file = e.target.files[0];
        e.target.value = '';    //so picking the same file again re-triggers onChange
        this.uploadXlsxFile(file);
    }

    handleUploadDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.uploadXlsxFile(e.dataTransfer.files[0]);
    }

    handleUploadDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }

    renderUploadModal = () => {
        return (
            <Modal
            show={this.state.showUploadPopup}
            onHide={this.handleCloseUpload}
            backdrop="static"
            centered
            >
            <Modal.Header closeButton>
                <Modal.Title><center><h1 class="pageTitle">Upload XLSX</h1></center></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div
                    onDrop={this.handleUploadDrop}
                    onDragOver={this.handleUploadDragOver}
                    style={{ border: '2px dashed #282c34', borderRadius: '0.5rem', padding: '2rem', textAlign: 'center', marginBottom: '1rem' }}
                >
                    Drag &amp; drop an .xlsx file here
                </div>
                <center><input type="file" accept=".xlsx" onChange={this.handleUploadFileSelected} /></center>
            </Modal.Body>
            <Modal.Footer>
                <span className="userAddErr">{this.state.uploadMsg}</span>
                <Button onClick={this.handleCloseUpload}>Close</Button>
            </Modal.Footer>
            </Modal>
        );
    }

    handleCloseCategory = () => {
        this.setState({ showAddCategory: false });
    }

    openCategoryStringPopup = () => {
        this.setState({ showCategoryStringPopup: true, categoryStringInput: this.state.categoryTitle });
    }

    handleCloseCategoryString = () => {
        this.setState({ showCategoryStringPopup: false });
    }

    handleCategoryStringChange = (event) => {
        this.setState({ categoryStringInput: event.target.value });
    }

    handleSaveCategoryString = (event) => {
        event.preventDefault();
        fetch('set_muster_point_string', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "value=" + encodeURIComponent(this.state.categoryStringInput)
        })
        .then(res => res.json())
        .then(data => {
            if (data && data[0] && data[0].success === 'true') {
                this.setState({ categoryTitle: this.state.categoryStringInput, showCategoryStringPopup: false });
                if (this.props.reloadMusterPointString) {
                    this.props.reloadMusterPointString();
                }
            }
        })
        .catch(console.log)
    }

    renderCategoryStringModal = () => {
        return (
            <Modal
            show={this.state.showCategoryStringPopup}
            onHide={this.handleCloseCategoryString}
            backdrop="static"
            centered
            >
            <Modal.Header closeButton>
                <Modal.Title><center><h1 class="pageTitle">Muster Point Label</h1></center></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <input name="txtCategoryString" type="text" value={this.state.categoryStringInput} onChange={this.handleCategoryStringChange} />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={this.handleSaveCategoryString}>Save</Button>
                <Button onClick={this.handleCloseCategoryString}>Close</Button>
            </Modal.Footer>
            </Modal>
        );
    }

    handleSubmitCategory = () => {
        fetch('asset_category_add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "title=" + this.frmAddCategory.current.GetTitle() + "&colour=" + this.frmAddCategory.current.GetColour()
                  + "&x=" + this.frmAddCategory.current.GetX() + "&y=" + this.frmAddCategory.current.GetY() + "&z=" + this.frmAddCategory.current.GetZ()
                  + "&azimuth=" + this.frmAddCategory.current.GetAzimuth()
        })
        .then(res => res.json())
        .then(data =>
        {
            if ('true' === data[0].add)
            {
                this.setState({
                    showAddCategory: false
                });

                this.reloadCategories();
            }
            else
            {
                this.setState({
                    errMsg: data[0].msg
                });
            }
        })
    }

    showUpdateCategory = (category) => {
        //console.log("Show update category");
        //console.log(category);
        this.setState({
            updateCategory: category,
            updateCategoryVisible: true,
            errMsg: ''
        });
    }

    hideUpdateCategory = () => {
        this.reloadRows();
        this.setState({
            updateCategoryVisible: false,
            errMsg: ''
        });
    }

    handleUpdateTitleChange = (e) => {
        let category = this.state.updateCategory;
        category.title = e.target.value;
        this.setState({
            updateCategory: category
        });
    }

    handleUpdateColourChange = (e) => {
        let category = this.state.updateCategory;
        category.colour = e.target.value;
        this.setState({
            updateCategory: category
        });
    }

    handleUpdateXChange = (e) => {
        let category = this.state.updateCategory;
        category.x = e.target.value;
        this.setState({
            updateCategory: category
        });
    }

    handleUpdateYChange = (e) => {
        let category = this.state.updateCategory;
        category.y = e.target.value;
        this.setState({
            updateCategory: category
        });
    }

    handleUpdateZChange = (e) => {
        let category = this.state.updateCategory;
        category.z = e.target.value;
        this.setState({
            updateCategory: category
        });
    }

    handleUpdateCategoryIdChange = (e) => {
        let category = this.state.updateCategory;
        category.categoryId = e.target.value;
        this.setState({
            updateCategory: category
        });
    }

    handleUpdateAzimuthChange = (e) => {
        let category = this.state.updateCategory;
        category.azimuth = e.target.value;
        this.setState({
            updateCategory: category
        });
    }

    handleUpdateBaselineRecordingChange = (e) => {
        let category = this.state.updateCategory;
        category.baselineRecording = e.target.value;

        //console.log("handleUpdateBaselineRecordingChange");
        //console.log(category.baselineRecording);

        this.setState({
            updateCategory: category
        });
    }

    render() {
        const numCategories = this.filteredRows().length;
        if (1 === this.props.accessLevel)
        {
            return (<div>

                <Modal
                show={this.state.showAddCategory}
                onHide={this.handleCloseCategory}
                backdrop="static"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title><center><h1 class="pageTitle">Add new {this.state.categoryTitle}</h1></center></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <CategoryAdd ref={this.frmAddCategory} reloadCategory={this.reloadCategories} showCoordinates={true} />
                </Modal.Body>

                <Modal.Footer>
                    <span className="CategoryAddSpan">{this.state.errMsg}</span>
                    <Button onClick={this.handleSubmitCategory}>Add</Button>
                    <Button onClick={this.handleCloseCategory}>Close</Button>
                </Modal.Footer>
                </Modal>

                <MusterPointChange
                musterTitle={this.state.categoryTitle}
                updateCategoryVisible={this.state.updateCategoryVisible}
                hideUpdateCategory={this.hideUpdateCategory}
                handleUpdateTitleChange={this.handleUpdateTitleChange}
                handleUpdateColourChange={this.handleUpdateColourChange}
                handleUpdateBaselineRecordingChange={this.handleUpdateBaselineRecordingChange}
                handleUpdateCategoryIdChange={this.handleUpdateCategoryIdChange}
                handleUpdateXChange={this.handleUpdateXChange}
                handleUpdateYChange={this.handleUpdateYChange}
                handleUpdateZChange={this.handleUpdateZChange}
                handleUpdateAzimuthChange={this.handleUpdateAzimuthChange}
                category={this.state.updateCategory}>
                </MusterPointChange>

                {this.renderCategoryStringModal()}
                <Jumbotron className="jumboHeader">
                <center><h1 class="pageTitle" onClick={this.openCategoryStringPopup} style={{ cursor: 'pointer' }}>{this.state.categoryTitle}</h1></center>
                <center><h2 class="pageTitle">{this.state.categoryTitle} Count: {numCategories}</h2></center>
                <center><Button onClick={this.handleDownloadCsv} className="btnCategory">Download XLSX</Button> <Button onClick={this.handleShowUpload} className="btnCategory">Upload XLSX</Button></center>
                </Jumbotron>
                {this.renderUploadModal()}
                {this.renderTitleSearch()}
                <div class="paginationEvents">{this.renderPagination()}</div>
                <AssetCategoryList rows={this.pageRows()} showUpdateCategory={this.showUpdateCategory} accessLevel={this.props.accessLevel} reloadCategories={this.reloadCategories} ref="categorylist"/>
                <Button onClick={this.handleAddCategory} className="btnCategory">
                Add {this.state.categoryTitle}
                </Button>

                </div>
            )
        }
        else
        {
            return (<div>

                <MusterPointChange
                musterTitle={this.state.categoryTitle}
                updateCategoryVisible={this.state.updateCategoryVisible}
                hideUpdateCategory={this.hideUpdateCategory}
                handleUpdateTitleChange={this.handleUpdateTitleChange}
                handleUpdateColourChange={this.handleUpdateColourChange}
                handleUpdateBaselineRecordingChange={this.handleUpdateBaselineRecordingChange}
                handleUpdateCategoryIdChange={this.handleUpdateCategoryIdChange}
                handleUpdateXChange={this.handleUpdateXChange}
                handleUpdateYChange={this.handleUpdateYChange}
                handleUpdateZChange={this.handleUpdateZChange}
                handleUpdateAzimuthChange={this.handleUpdateAzimuthChange}
                category={this.state.updateCategory}>
                </MusterPointChange>

                {this.renderCategoryStringModal()}
                <Jumbotron className="jumboHeader">
                <center><h1 class="pageTitle" onClick={this.openCategoryStringPopup} style={{ cursor: 'pointer' }}>{this.state.categoryTitle}</h1></center>
                <center><h2 class="pageTitle">{this.state.categoryTitle} Count: {numCategories}</h2></center>
                <center><Button onClick={this.handleDownloadCsv} className="btnCategory">Download XLSX</Button></center>
                </Jumbotron>
                {this.renderTitleSearch()}
                <div class="paginationEvents">{this.renderPagination()}</div>
                <AssetCategoryList rows={this.pageRows()} showUpdateCategory={this.showUpdateCategory} accessLevel={this.props.accessLevel} reloadCategories={this.reloadCategories} ref="categorylist"/>
                </div>)
        }
    }
}

export default MusterPoints;
